import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import DialogModal from '../../common/DialogModal';
import Button from '../../Parts/Button';
import Loader from '../../Parts/Loader';
import { TimelineIconType, TimelineLabelType } from "../../../constants/ComponentTypes";
import { format } from 'date-fns';
import { connect } from 'react-redux';
import { getRecordingData } from '../../../redux/actions/Timeline';

const styles = () => ({
  paper: {
    maxHeight: 'unset',
    background: "#F4F6F9",
    width: '600px',
  },

  contentContainer: {
    padding: '25px',
    margin: 0,
    textAlign: 'left',
    backgroundColor: '#F4F6F9',
  },

  header: {
    fontSize: '14px',
  },

  desc: {
    marginTop: '10px',
    fontSize: '13px',
    overflow: 'scroll',
    backgroundColor: '#FFFFFF',
    height: "163px",
    padding: "20px",
    whiteSpace: "pre-wrap",
    border: "1px solid #D9DBDF",
  },

  leadNoteLabel: {
    marginTop: '30px',
    fontSize: '14px',
  },

  leadNote: {
    marginTop: '15px',
    fontSize: '13px',
    overflow: 'scroll',
    backgroundColor: '#FFFFFF',
    height: '53px',
    padding: "20px",
    whiteSpace: "pre-wrap",
    border: "1px solid #D9DBDF",
  },

  buttonContainer: {
    marginTop: '40px',
  },

  audio: {
    marginTop: '20px',
    width: '100%',
  }
});

class FollowCallDetailDialog extends React.Component {
  state = {
    audioSource: null,
  }
  componentDidMount() {
    const { status, user } = this.props;
    // 録音データを取得する対象のステータス
    const recordingStatuses = [
      TimelineLabelType.CONNECT.value,
      TimelineLabelType.SENT_DOCUMENT.value,
      TimelineLabelType.APPOINTMENT.value,
    ]
    // フォローコールの録音データを表示できるユーザで対象のステータスのみ録音データを取得する
    if (user && user.can_display_follow_call_audio && recordingStatuses.includes(status.status_label_type)) {
      this.props.getRecordingData(status.id)
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.recordingsData && this.props.recordingsData !== prevProps.recordingsData) {
      this.setState({
        audioSource: 'data:audio/mp3;base64,' + this.props.recordingsData,
      })
    }
  }

  calcCount = () => {
    const { status, statuses } = this.props;
    let index = statuses.filter(item => {
      return item.type === TimelineIconType.FOLLOW_CALL_USER_STATUS || item.type === TimelineIconType.RESEARCHER_USER_STATUS
    })
      .findIndex(item => item.id === status.id);

    return index + 1;
  }

  renderButtons = () => {
    const { classes } = this.props;

    return (
      <div className={classes.buttonContainer}>
        <Button
          handleClickButton={this.props.toggleDialog}
          text="確認して閉じる"
          style={{ background: '#2E68F6', color: '#FFFFFF', width: '100%' }}
        >
        </Button>
      </div>
    )
  }

  render() {
    const { classes, toggleDialog, isOpen, status } = this.props;

    const count = this.calcCount();

    return (
      <DialogModal
        title={'フォローコール' + count + '回目'}
        open={isOpen}
        onClose={toggleDialog}
        maxWidth={false}
        classes={{
          paper: classes.paper,
          contentContainer: classes.contentContainer
        }}
      >
        {!status ? (
          <Loader type="color" size="large" />
        ) : (
          <div>
            <div className={classes.header}>
              {format(new Date(status.created_at), "yyyy年MM月dd日") + "に" + count + `回目のフォローコールをしました。以下は担当者のメモ${this.state.audioSource ? '及び電話の録音データ' : ''}になります。`}
            </div>
            <div className={classes.desc}>
              {status.desc}
            </div>
            <div className={classes.leadNoteLabel}>リード情報</div>
            <div className={classes.leadNote}>
              {status.lead_note}
            </div>
            {/* 商談獲得の場合で商談日時があれば商談日時を表示 */}
            {TimelineLabelType.APPOINTMENT.value === status.status_label_type && status.scheduled_at && (
              <div className={classes.leadNoteLabel}>商談日時：{format(new Date(status.scheduled_at), "yyyy年MM月dd日 HH:mm")}</div>
            )}
            {this.state.audioSource && (
              <audio controlsList="nodownload" className={classes.audio} src={this.state.audioSource} controls></audio>
            )}
            {this.renderButtons()}
          </div>
        )}
      </DialogModal>
    );
  }
}

FollowCallDetailDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  status: PropTypes.object.isRequired,
  statuses: PropTypes.array.isRequired,
  getRecordingData: PropTypes.func.isRequired,
  recordingsData: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
  return {
    user: state.accountSetting.user,
    recordingsData: state.timeline.recordingsData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    // 録音データを取得
    getRecordingData(id) {
      dispatch(getRecordingData(id));
    },
  };
};

export default withStyles(styles)(connect(
  mapStateToProps,
  mapDispatchToProps
)(FollowCallDetailDialog));



// WEBPACK FOOTER //
// ./src/components/Timeline/dialogs/FollowCallDetailDialog.jsx